import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicRoutingModule } from './public-routing.module';
import { QrsWrapperComponent } from './components/qrs-wrapper/qrs-wrapper.component';
import { SharedModule } from '../shared/shared.module';
import { QrsImagesComponent } from './components/qrs-wrapper/qrs-images/qrs-images.component';
import { QrsAppComponent } from './components/qrs-wrapper/qrs-app/qrs-app.component';
import { QrsBusinessPageComponent } from './components/qrs-wrapper/qrs-business-page/qrs-business-page.component';
import { QrsEventComponent } from './components/qrs-wrapper/qrs-event/qrs-event.component';
import { QrsCouponComponent } from './components/qrs-wrapper/qrs-coupon/qrs-coupon.component';
import { QrsFeedbackComponent } from './components/qrs-wrapper/qrs-feedback/qrs-feedback.component';
import { QrsMp3Component } from './components/qrs-wrapper/qrs-mp3/qrs-mp3.component';
import { QrsPdfComponent } from './components/qrs-wrapper/qrs-pdf/qrs-pdf.component';
import { QrsRatingComponent } from './components/qrs-wrapper/qrs-rating/qrs-rating.component';
import { QrsSocialMediaComponent } from './components/qrs-wrapper/qrs-social-media/qrs-social-media.component';
import { QrsVacancyComponent } from './components/qrs-wrapper/qrs-vacancy/qrs-vacancy.component';
import { QrsVcardProComponent } from './components/qrs-wrapper/qrs-vcard-pro/qrs-vcard-pro.component';
import { QrsVideoComponent } from './components/qrs-wrapper/qrs-video/qrs-video.component';
import { RatingModule } from 'ng-starrating';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QrNotFoundComponent } from './components/qrs-wrapper/qr-not-found/qr-not-found.component';
import { PopupsWrapperComponent } from './components/popups-wrapper/popups-wrapper.component';
import { PublicWrapperComponent } from './components/public-wrapper/public-wrapper.component';
import { QrsPetComponent } from './components/qrs-wrapper/qrs-pet/qrs-pet.component';
import { QrsRestaurantMenuComponent } from './components/qrs-wrapper/qrs-restaurant-menu/qrs-restaurant-menu.component';
import { QrsLongPlainTextComponent } from './components/qrs-wrapper/qrs-long-plain-text/qrs-long-plain-text.component';
import { QrsMemoriesComponent } from './components/qrs-wrapper/qrs-memories/qrs-memories.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    QrsWrapperComponent,
    QrsImagesComponent,
    QrsAppComponent,
    QrsBusinessPageComponent,
    QrsEventComponent,
    QrsCouponComponent,
    QrsFeedbackComponent,
    QrsMp3Component,
    QrsPdfComponent,
    QrsRatingComponent,
    QrsSocialMediaComponent,
    QrsVacancyComponent,
    QrsVcardProComponent,
    QrsVideoComponent,
    QrNotFoundComponent,
    PopupsWrapperComponent,
    PublicWrapperComponent,
    QrsPetComponent,
    QrsRestaurantMenuComponent,
    QrsLongPlainTextComponent,
    QrsMemoriesComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    FormsModule,
    RatingModule,
    CommonModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    PublicRoutingModule
  ]
})
export class PublicModule { }
